var React = require('react');

function RexlabsChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m4 6 4 4 4-4","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

RexlabsChevronDown.defaultProps = {"data-es-keys":"undefined.icon","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = RexlabsChevronDown;

RexlabsChevronDown.default = RexlabsChevronDown;
